import { render, staticRenderFns } from "./view_po.vue?vue&type=template&id=58596ec6&scoped=true&"
import script from "./view_po.vue?vue&type=script&lang=js&"
export * from "./view_po.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58596ec6",
  null
  
)

export default component.exports